export const HUB_NAME = 'MPWHub';
export const CONNECTION_RETRY_DELAY = 5;
export const CONNECTION_TRY_FOR_OFFLINE_MODE = 1;
export const SUPPORT_MESSAGE_TITLES = ['RECALCULATE RECIPE NUTRIENTS'];



// WEBPACK FOOTER //
// ./src/api/SignalR/helpers/constants.js